import { AvailabilityBlock, DateInterval, ReservationBlock } from '../hooks/useDirectAvailability';
import axiosInstance from '../../../services/axiosInstance';

export interface FetchAvailabilityResponse {
  availabilities: AvailabilityBlock[];
  reservations: ReservationBlock[];
  dateOverrides: Record<string, DateInterval[]>;
  pauseMinutes: 0 | 5 | 10 | 15 | 20 | 30;
}

export interface FetchWeekSlotsResponse {
  slots_by_date: Record<string, DateInterval[]>;
}

export interface SaveAvailabilityRequest {
  week_from: string;
  availabilities: AvailabilityBlock[];
  dateOverrides: Record<string, DateInterval[]>;
  pauseMinutes: 0 | 5 | 10 | 15 | 20 | 30;
}

export const availabilityApi = {
  /**
   * Fetch the current availability, reservations, and settings
   */
  fetchAvailabilityData: async (): Promise<FetchAvailabilityResponse> => {
    const response = await axiosInstance.get('/api/v1/availability/data');
    return response.data;
  },

  /**
   * Fetch the slots specific to a week (starting from 'from' date)
   */
  fetchWeekSlots: async (from: string): Promise<FetchWeekSlotsResponse> => {
    const response = await axiosInstance.get(`/api/v1/availability/week?from=${from}`);
    return response.data;
  },

  /**
   * Save the updated availability, overrides, and settings
   */
  saveAvailabilityData: async (data: SaveAvailabilityRequest): Promise<void> => {
    await axiosInstance.post('/api/v1/availability/save', data);
  },

  /**
   * Trigger the replication of the current weekly schedule
   */
  replicateAvailability: async (untilDate: string, fromDate?: string): Promise<void> => {
    await axiosInstance.post('/api/v1/availability/replicate', { 
      until_date: untilDate,
      from_date: fromDate
    });
  }
};
